import { ApiService } from "../api.service";
import { Router } from "@angular/router";
var HrReportOverviewComponent = (function () {
    function HrReportOverviewComponent(apiService, router) {
        this.apiService = apiService;
        this.router = router;
    }
    HrReportOverviewComponent.prototype.ngOnInit = function () {
        this.personalReportListSelected = true;
        this.coachSelected = true;
        this.getPersons();
        /*this.users= [
            {
                "name":"陈玉华",
                "department":"CFD部门",
                "title":"总经理"
            },
            {
                "name":"陈玉华",
                "department":"CFD部门",
                "title":"总经理"
            },
            {
                "name":"陈玉华",
                "department":"CFD部门",
                "title":"总经理"
            },
            {
                "name":"陈玉华",
                "department":"CFD部门",
                "title":"总经理"
            }
        ];

        this.companyReport={
            "users":[
                {"name":"余志军🏝","status":"未完成","level":""},
                {"name":"康康先生","status":"未完成","level":""},
                {"name":"Ting💢","status":"未完成","level":""},
                {"name":"希昔茜","status":"未完成","level":""},
                {"name":"roman_timeout","status":"未完成","level":""},
                {"name":"骆应罗","status":"未完成","level":""},
                {"name":"Sky","status":"未完成","level":""}
                ],
            "preSurveyAvg":2,
            "postSurveyAvg":6,
            "userKas":[
                {"name":"余志军🏝","bestKaName":"提供支持","bestKaLevel":4,"worstKaName":"制定行动计划 ","worstKaLevel":1},
                {"name":"康康先生","bestKaName":"说明讨论的目的","bestKaLevel":5,"worstKaName":"明确表达绩效挑战","worstKaLevel":1},
                {"name":"Ting💢","bestKaName":"明确表达绩效挑战","bestKaLevel":7,"worstKaName":"维持动力","worstKaLevel":1},
                {"name":"希昔茜","bestKaName":"制定行动计划 ","bestKaLevel":5,"worstKaName":"制定行动计划 ","worstKaLevel":1}
                ]
        };*/
    };
    HrReportOverviewComponent.prototype.ngAfterViewInit = function () {
        document.documentElement.style.backgroundColor = "#3d3d6e";
        var htmlFontSize;
        if (window.screen.width < window.screen.height) {
            htmlFontSize = window.screen.width / 7.5;
        }
        else {
            htmlFontSize = window.screen.height / 7.5;
        }
        document.documentElement.style.fontSize = htmlFontSize + "px";
    };
    HrReportOverviewComponent.prototype.selectReportList = function (bool) {
        var _this = this;
        this.personalReportListSelected = bool;
        if (!bool) {
            if (!this.companyReport) {
                this.apiService.getCompanyReport().subscribe(function (result) {
                    _this.companyReport = result;
                    _this.selectedAbilityIndex = 0;
                });
            }
        }
    };
    HrReportOverviewComponent.prototype.selectAbility = function (index) {
        this.selectedAbilityIndex = index;
    };
    HrReportOverviewComponent.prototype.showDetailReport = function (userId) {
        var link = ['graduation', 0, userId, 0];
        this.router.navigate(link);
    };
    HrReportOverviewComponent.prototype.getPersons = function () {
        var _this = this;
        this.apiService.getHrReports().subscribe(function (result) {
            _this.users = result;
        });
    };
    return HrReportOverviewComponent;
}());
export { HrReportOverviewComponent };



// WEBPACK FOOTER //
// ./src/app/hr-report-overview/hr-report-overview.component.ts.pre-build-optimizer.js